/// <reference path="../../../../node_modules/bingmaps/types/MicrosoftMaps/Microsoft.Maps.All.d.ts" />
import {
  Injectable} from '@angular/core';
import {AppConfigService} from "../../config/app-config.service";
import {MessageService} from "../../messages/message.service";
import {TranslateService} from "../../shared/translate.service";
import {AbstractMapService} from "./abstract-map.service";
import {UserPositionService} from "./user-position.service";

@Injectable({
  providedIn: "root"
})
export class BingMapService extends AbstractMapService {

  private bingWatchId;

  constructor(protected config: AppConfigService,
              protected messageService: MessageService,
              protected translateService: TranslateService,
              protected userPositionService: UserPositionService) {
    super(config, messageService, translateService, userPositionService);
  }
}

